import { get } from "./axios";

//获取航班详情
export function getGeoData(flightAltitude) {
  return get(`/app/geo/${flightAltitude}`);
}



// WEBPACK FOOTER //
// ./src/api/app.js